


































import Vue from "vue";
import { LPopup } from "vue2-leaflet";
import Paragraph from "@/components/Text/Global/Paragraph.vue";

export default Vue.extend({
  name: "PopupModal",
  components: { LPopup, Paragraph },
  props: {
    data: {
      type: Object
    }
  }
});
